import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import Navbar from "../components/navbar";
import Footer from "../components/footer";
import { auth } from "../firebaseConfig";
import { signInWithEmailAndPassword, sendPasswordResetEmail } from "firebase/auth";
import { db } from "../firebaseConfig";
import { doc, getDoc, setDoc } from "firebase/firestore";
import "../css/LoginPage.css";

export default function LoginPage() {
    const [form, setForm] = useState({ email: "", password: "" });
    const [error, setError] = useState("");
    const [resetMode, setResetMode] = useState(false);
    const [resetEmail, setResetEmail] = useState("");
    const [resetMessage, setResetMessage] = useState("");
    const [resetError, setResetError] = useState("");
    const navigate = useNavigate();

    const handleChange = (e) => {
        setForm((prev) => ({ ...prev, [e.target.name]: e.target.value }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setError("");
        try {
            const userCredential = await signInWithEmailAndPassword(auth, form.email, form.password);
            const user = userCredential.user;
            // ensure user role exists, default to "viewer"
            const userRef = doc(db, "users", user.uid);
            const snap = await getDoc(userRef);
            const userData = snap.exists() ? snap.data() : {};
            const updates = {};
            // Default role to viewer if not set
            if (!userData.role) {
                updates.role = "viewer";
            }
            // Ensure email is stored
            if (!userData.email) {
                updates.email = user.email;
            }
            // Default name to displayName if available, otherwise "dummy"
            if (!userData.name) {
                updates.name = user.displayName || "dummy";
            }
            // Only write if there are fields to update
            if (Object.keys(updates).length > 0) {
                await setDoc(userRef, updates, { merge: true });
            }
            navigate("/national");  // redirect to editor or dashboard
        } catch (err) {
            setError("Invalid credentials. Please try again.");
            console.error("Login error", err);
        }
    };

    const handleResetSubmit = async (e) => {
        e.preventDefault();
        setResetError("");
        setResetMessage("");
        try {
            await sendPasswordResetEmail(auth, resetEmail);
            setResetMessage("Password reset link sent! Check your email.");
        } catch (err) {
            setResetError("Failed to send reset email. Please try again.");
            console.error("Reset error", err);
        }
    };

    return (
        <div className="login-css">
            <Navbar />
            <main className="login-page">
                <div className="login-hero">
                    <h1>Staff Login</h1>
                    <p>Enter your credentials to access the editor.</p>
                </div>
                {resetMode ? (
                    <form className="login-form" onSubmit={handleResetSubmit}>
                        <input
                            type="email"
                            name="resetEmail"
                            placeholder="Enter your email"
                            value={resetEmail}
                            onChange={(e) => setResetEmail(e.target.value)}
                            required
                            className="login-input"
                        />
                        <button type="submit" className="login-button">
                            Send reset link
                        </button>
                        {resetMessage && <p className="login-success">{resetMessage}</p>}
                        {resetError && <p className="login-error">{resetError}</p>}
                        <p className="login-forgot" onClick={() => setResetMode(false)}>
                            ← Back to login
                        </p>
                    </form>
                ) : (
                    <form className="login-form" onSubmit={handleSubmit}>
                        <input
                            type="email"
                            name="email"
                            placeholder="Email Address"
                            value={form.email}
                            onChange={handleChange}
                            required
                            className="login-input"
                        />
                        <input
                            type="password"
                            name="password"
                            placeholder="Password"
                            value={form.password}
                            onChange={handleChange}
                            required
                            className="login-input"
                        />
                        <button type="submit" className="login-button">
                            Sign In
                        </button>
                        {error && <p className="login-error">{error}</p>}
                        <p className="login-forgot" onClick={() => setResetMode(true)}>
                            Forgot password?
                        </p>
                    </form>
                )}
            </main>
            <Footer />
        </div>
    );
}
